export default "__VITE_ASSET__B5w4wnxM__"